import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { DateRange } from '@mui/lab/DateRangePicker';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import axios from "axios";
import * as CSS from "csstype";
import React, { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Link, useHistory, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import { API_URL, AUTHORITY_LIST, AUTHORITY_LIST_USER_ADMIN, AUTHORITY_NO_LIST } from "../../Const";
import ConfirmDialog from "../Dialog";
import GenericTemplate from "../templates/GenericTemplate";
import { useLoadingOverlay } from '../../utilHooks/loadingOverlay';
import { Label } from '@mui/icons-material';

// フォームの型
interface UserCreateFormInput {
  // email: string,
  user_name: string,
  authority_code: string
}

// バリデーションルール
const schema = yup.object({
  // email: yup
  //   .string()
  //   .required('必須項目です')
  //   .email('正しいメールアドレス形式で入力してください'),
  user_name: yup
    .string()
    .required('必須項目です'),
  authority_code: yup
    .string()
    .required('必須項目です')
})



// const currencies = [
//   {
//     value: '1',
//     label: '一般',
//   },
//   {
//     value: '2',
//     label: '管理者',
//   },
// ];

const useStyles = makeStyles(() =>
  createStyles({
    datePicker: {
      width: '25ch',
    },
  })
);

const msgStyle: CSS.Properties = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#3f3f3f",
  margin: "5px",
  textAlign: "left"
}


const UserEdit: React.FC = () => {
  const { openLoading, closeLoading } = useLoadingOverlay()

  const history = useHistory();
  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')

  // 権限
  const currencies = jsonlist.user.authority_code === AUTHORITY_NO_LIST.SYSTEM_ADMIN.toString() ?
    AUTHORITY_LIST : AUTHORITY_LIST_USER_ADMIN;

  const { state } = useLocation();
  // console.log('state:', state)
  // const s_user_id = (state as any)?.id;
  const s_company_id = (state as any)?.company_id;
  const s_user_name = (state as any)?.user_name;
  const s_user_name_kana = (state as any)?.user_name_kana;
  const s_user_id = (state as any)?.user_id;
  const s_authority_code = (state as any)?.authority_code;
  const s_remarks = (state as any)?.remarks;


  /*送信パラメータ*/
  const [user_name, setUserName] = useState(s_user_name);
  const [user_name_kana, setUserNameKana] = useState(s_user_name_kana);
  const [user_id, setUserId] = useState(s_user_id);
  const [authority_code, setAuthorityCode] = useState(s_authority_code);
  const [remarks, setRemarks] = useState(s_remarks);
  /* 送信パラメータ値設定 */
  const changeUserName = (e: any) => {
    setUserName(e.target.value);
  }
  const changeUserNameKana = (e: any) => {
    setUserNameKana(e.target.value);
  }
  const changeUserId = (e: any) => {
    setUserId(e.target.value);
  }
  const changeRemarks = (e: any) => {
    setRemarks(e.target.value);
  }

  //バリデーション設定
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserCreateFormInput>({
    resolver: yupResolver(schema),
  })




  const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
  const classes = useStyles();
  const [selectedDate, setSelectedData] = useState<MaterialUiPickersDate>(null);
  // const [currency, setCurrency] = React.useState(s_authority_code);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // setCurrency(event.target.value);
    setAuthorityCode(event.target.value);
  };


  // 更新ボタン押下時の処理
  const onSubmit: SubmitHandler<UserCreateFormInput> = (data) => {
    handleClickOpenEdit()
  }

  /*スピナー処理*/
  const [loading, setLoading] = React.useState(false);
  /*スピナー処理*/

  /*ダイアログ処理(キャンセル)*/
  const [openCancel, setOpenCancel] = React.useState(false);
  const handleClickOpenCancel = () => {
    setOpenCancel(true);
  };
  const gotoDetail = () => {
    // 詳細に戻る
    history.push({ pathname: "/UserDetail", state: { id: s_user_id, comid: s_company_id } });
  };
  const setConfirmOpenCancel = (check: any) => {
    setOpenCancel(check)
  };
  /*ダイアログ処理(キャンセル)*/

  /*ダイアログ処理(追加)*/
  const [openEdit, setOpenEdit] = React.useState(false);
  const handleClickOpenEdit = () => {
    setOpenEdit(true);
  };
  const editUser = () => {
    if (!loading) {
      setLoading(true);
    }

    openLoading()
    axios.post(API_URL.USER_UPDATE,
      {
        "company_id": s_company_id,
        "dealer_info_id": s_company_id,
        "user_name": user_name,
        "user_name_kana": user_name_kana,
        "user_id": user_id,
        "mail_address": user_id,
        // "password": password,
        "available_status": "1",
        "authority_code": authority_code,
        "remarks": remarks
      },
      { headers: { Authorization: jsonlist.token.IdToken } },
    )
      .then(res => {
        // 詳細に戻る
        closeLoading() // history.pushの直後の場合、closeがうまくいかないケースがあるためthen内に適応
        history.push({ pathname: "/UserDetail", state: { id: s_user_id, comid: s_company_id } });
      })
      .catch(error => {
        console.log('error:', error)
        setLoading(false);
      })
      .finally(() => {
        closeLoading()
      })

  };
  const setConfirmOpenEdit = (check: any) => {
    setOpenEdit(check)
  };
  /*ダイアログ処理(追加)*/





  return (

    <GenericTemplate title="ユーザ 編集">
      <div>
        <ConfirmDialog
          title="入力されているデータで更新しますか？"
          open={openEdit}
          setOpen={setConfirmOpenEdit}
          onConfirm={handleSubmit(editUser)}
          loading={loading}
        >
          更新後詳細画面へ戻ります
        </ConfirmDialog>
      </div>

      <div>
        <ConfirmDialog
          title="詳細に戻りますか？"
          open={openCancel}
          setOpen={setConfirmOpenCancel}
          onConfirm={gotoDetail}
          loading={loading}
        >
          変更したデータは破棄されます
        </ConfirmDialog>
      </div>


      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} >
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">ユーザー名*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              required
              // label="ユーザー名"
              type="string"
              {...register('user_name')}
              error={'user_name' in errors}
              helperText={errors.user_name?.message}
              defaultValue={user_name}
              onChange={changeUserName}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">フリガナ*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              //  label="フリガナ" 
              onChange={changeUserNameKana}
              defaultValue={user_name_kana}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">メールアドレス*</Grid>
          <Grid item={true} sm={6} md={3} xs={12}>
            <TextField
              inputProps={{ readOnly: true }}
              value={user_id}
            />
            {/* <TextField
                inputProps={{ readonly: true }}
                required
                // label="メールアドレス"
                type="email"
                {...register('email')}
                error={'email' in errors}
                helperText={errors.email?.message}
                onChange={changeUserId}
                defaultValue={user_id}
              /> */}
          </Grid>
          <Grid item={true} sm={3} md={6} xs={12} className="mailaddress_caution">
            ※メールアドレスは変更できません。<br />
            変更を希望の方は契約管理者にお問い合わせください。
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">パスワード*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <Button
              className="btnlink"
              color="inherit"
              variant="contained"
              size="large"
              // component={Link}
              // onClick={handleClickOpenCancel}
              component={Link}
              to={{ pathname: "/UsereditPassword", state: { user_id: user_id, company_id: s_company_id, user_name: user_name, user_name_kana: user_name_kana, authority_code: authority_code, remarks: remarks } }}
            // to="/Userlist"
            >
              パスワードを変更
            </Button>
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}></Stack>
      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">権限*</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              required
              // label="権限"
              type="string"
              {...register('authority_code')}
              error={'authority_code' in errors}
              helperText={errors.authority_code?.message}
              id="outlined-select-currency-native"
              select
              value={authority_code}
              onChange={handleChange}
              SelectProps={{
                native: true,
              }}
              className="InsText2"
              variant="outlined"
            >
              {currencies.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={3} margin={2}>
        <Grid item={true} container spacing={0} justifyContent="flex-start">
          <Grid item={true} sm={3} md={2} xs={12} className="detail-title">備考</Grid>
          <Grid item={true} sm={9} md={10} xs={12}>
            <TextField
              id="outlined-basic"
              // label="備考"
              variant="outlined"
              className="InsText3"
              multiline={true}
              rows={2}
              maxRows={4}
              onChange={changeRemarks}
              defaultValue={remarks}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack spacing={0} margin={0}>
        <Grid item={true} container spacing={0}>
          <Grid item={true} sm={3} md={2} xs={10}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              // onClick={handleClickOpenAdd}
              onClick={handleSubmit(onSubmit)}
            >
              更新
            </Button>
          </Grid>
          <Grid item={true} sm={5} md={6} xs={10}>
            <Button
              className="btnlink"
              color="primary"
              variant="contained"
              size="large"
              // component={Link}
              onClick={handleClickOpenCancel}
            // to="/Userlist"
            >
              キャンセル
            </Button>
          </Grid>
        </Grid>
      </Stack>



    </GenericTemplate>
  );
};

export default UserEdit;